import React, { useState, useEffect } from 'react';
import { message, Modal, Upload, Image } from 'antd';
import { PlusOutlined } from '@ant-design/icons';
import type { RcFile, UploadProps } from 'antd/es/upload';
import type { UploadFile } from 'antd/es/upload/interface';
const COMMON_PREFIX = 'https://s3-yspu-cdn.didistatic.com'

const getBase64 = (file: RcFile): Promise<string> =>
	new Promise((resolve, reject) => {
		const reader = new FileReader();
		reader.readAsDataURL(file);
		reader.onload = () => resolve(reader.result as string);
		reader.onerror = error => reject(error);
	});

type PropsType = {
	action?: any;
	name?: any;
	value?: any;
	onChange?: any;
	fileSize?: any;
	hideTitle?: boolean;
	accept?: string;
	isDisabled?: any;
	setIsUploading?: any;
  uploadBtnText?: string
};

// TODO:repeat code
const SPUploadPhotos: React.FC<PropsType> = props => {
	const { onChange, value, fileSize, hideTitle, accept, isDisabled, setIsUploading, uploadBtnText } = props;

	const [previewOpen, setPreviewOpen] = useState(false);
	const [previewImage, setPreviewImage] = useState('');
	const [previewTitle, setPreviewTitle] = useState('');

	const beforeUpload = (file: RcFile) => {
		const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png';
		if (!isJpgOrPng) {
			message.error('仅支持JPG/PNG格式!');
			return Upload.LIST_IGNORE;
		}
		const isLt2M = file.size / 1024 / 1024 < (fileSize || 5);
		if (!isLt2M) {
			message.error(`图片需小于${fileSize || 5}MB!`);
		}

		if (!isJpgOrPng || !isLt2M) return Upload.LIST_IGNORE;
	};

	const initFileList = (val: any) => {
		let list: any = [];

		let url = typeof val === 'string' ? val : val?.file_url;


		if (val) list.push({ uid: url, name: url, url, status: 'done', response: { data: val } });

		return list;
	};
	const [myFileList, setMyFileList] = useState<UploadFile[]>([]);

	const handleCancel = () => setPreviewOpen(false);

	const handlePreview = async (file: UploadFile) => {
		if (!file.url && !file.preview) {
			file.preview = await getBase64(file.originFileObj as RcFile);
		}

		setPreviewImage(file.url || (file.preview as string));
		setPreviewOpen(true);
		setPreviewTitle(file.name || file.url!.substring(file.url!.lastIndexOf('/') + 1));
	};

	const handleChange: UploadProps['onChange'] = ({ fileList: newFileList }) => {
		// 格式：[{status: 'done'}, {status: 'done'}]
		setMyFileList(newFileList);
		setIsUploading && setIsUploading(true);

		// 都上传完毕，没有uploading
		if (newFileList.find((f: any) => f.status != 'done') == undefined) {
			setIsUploading && setIsUploading(false);
			let errFile = newFileList.find((f: any) => f?.response?.data == null);

			if (errFile) message.error(errFile?.response?.msg || errFile?.response?.errmsg);

			let list = newFileList.filter((f: any) => f?.response?.data != null);

			setMyFileList(list);

			// 格式：[url, url, url]
			//onChange(list.map((f: any) => f?.response?.data))
			// 格式：url
			onChange(list.length > 0 ? list[0].response.data : '');
		}
		if (newFileList.find((f: any) => f.status != 'error') == undefined) {
			setIsUploading && setIsUploading(false);
		}
	};

	const uploadButton = (
		<div>
			<PlusOutlined />
			<div style={{ marginTop: 8 }}>{ uploadBtnText || '上传' }</div>
		</div>
	);

	useEffect(() => {
		setMyFileList(initFileList(value));
	}, [value]);

	return (
		<>
			<Upload
				name="file"
				listType="picture-card"
				beforeUpload={beforeUpload}
				action={props?.action}
				accept={accept}
				onPreview={handlePreview}
				onChange={handleChange}
				fileList={myFileList}
				showUploadList={true}
				disabled={isDisabled}
			>
				{myFileList.length >= 1 ? null : uploadButton}
			</Upload>
      {
        previewOpen && <Image
          preview={{
            visible: previewOpen,
            onVisibleChange: (visible) => setPreviewOpen(visible),
          }}
          wrapperStyle={{ display: 'none' }}
          alt="example" src={previewImage} />
      }
		</>
	);
};

export default SPUploadPhotos;
